// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1VnXF","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1wxNH"};